export default __webpack_public_path__ + "static/earthmap-ee934914f939d6300fa394d740f94a71.gif";